// Development environment
export const environment = {
  production: false,
  environmentName: 'development',
  apiUrl: 'https://dev-programvaultbe.cubusverde.com',
};
